import { EntityList } from '@/common/entityFramework/entityList/EntityList'
import { useModuleFromRoute } from '@/common/hooks/route/useModuleFromRoute';
import { useRsrc } from '@/common/rsrc/RsrcContext';
import { ExprUtils } from '@/common/utils/ExprUtils';
import { useCallback, useRef } from 'react';

export const EntityControlList = ({ parentEntity, parentEntityId }) => {

  const rsrc = useRsrc();
  const entityListRef = useRef();
  const module = useModuleFromRoute();

  const augRowsReq = useCallback((rowsReq) => {
    if (!parentEntity) return;
    rowsReq.expr = ExprUtils.whereParams('entity', parentEntity, 'entityId', parentEntityId);
  }, [parentEntity, parentEntityId])

  const download = useCallback((data) => {
    let job = {
      name: 'Export of ' + data.code,
      module: module,
      entity: data.entity,
      entityId: data.id,
      rsrcCode: 'ENTITY_CONTROL_EXPORT_PLUGIN',
      reqParamJson: JSON.stringify({ exportReq: {} }),
      cat: 'EXPORT'
    }

    rsrc.save('skdr', 'JOB', job).then((job) => {
      rsrc.start(job.id).then(run => {
      });
    });
  }, [module, rsrc]);

  const getContextMenuItems = useCallback((params) => {
    let contextMenus = entityListRef.current.getContextMenuItems(params);
    contextMenus.push(
      {
        name: 'Download',
        action: () => download(params.node.data),
        icon: '<span class = "fa fa-arrow-circle-down"></span>'
      }
    );
    return contextMenus;
  }, [entityListRef, download]);

  return (
    <EntityList
      entity="ENTITY_CONTROL"
      ref={entityListRef}
      augRowsReq={augRowsReq}
      gridOptions={{
        getContextMenuItems
      }}
    />
  )
}